import { configureStore } from "@reduxjs/toolkit";
import dashboardReducer from "../Slices/dashboardSlice";
import clientsReducer from "../Slices/clientsSlice";
import usersReducer from "../Slices/usersSlice";
import projectsReducer from "../Slices/projectsManagementSlice";
import projectDashboardReducer from "../Slices/projectDashboardSlice";
import clientDashboardReducer from "../Slices/clientDashboardSlice";
import teamsReducer from "../Slices/teamsSlice";
import sidebarReducer from "../Slices/sidebarSlice";
import sessionReducer from "../Slices/SessionSlice";
import authReducer from "../Slices/authSlice";
import apiStatusReducer from "../Slices/apiStatusSlice";
import moreSpaceReducer from "../Slices/moreSpaceSlice";
import issuesReducer from "../Slices/issuesSlice";
import backlogReducer from "../Slices/backlogSlice.js";
import timeEntriesReducer from "../Slices/timeEntrySlice";
import clientQbMappingReducer from "../Slices/clientQbMappingSlice";
import tabMappingReducer from "../Slices/tabMappingSlice";
import vendorTagMappingReducer from "../Slices/vendorTagMappingSlice";
import userRateMappingReducer from "../Slices/userRateMappingSlice";
import reportsReducer from "../Slices/reportsSlice";
import rolesReducer from "../Slices/rolesSlice";
import permissionsReducer from "../Slices/permissionsSlice";
import exportsReducer from "../Slices/exportsSlice";
import saasBillingReducer from "../Slices/saasBillingSlice";
import projectStatusesReducer from "../Slices/projectStatusesSlice";
import projectSettingsReducer from "../Slices/projectSettingsSlice";
import systemListsReducer from "../Slices/systemListsSlice";
import saasMasterModulesReducer from "../Slices/saasMasterModulesSlice";
import savedSearchesReducer from "../Slices/savedSearchesSlice";
import kanbanColumnsReducer from "../Slices/kanbanColumnsSlice";

export const store = configureStore({
  reducer: {
    dashboard: dashboardReducer,
    clients: clientsReducer,
    users: usersReducer,
    projects: projectsReducer,
    projectDashboard: projectDashboardReducer,
    clientDashboard: clientDashboardReducer,
    teams: teamsReducer,
    sidebar: sidebarReducer,
    session: sessionReducer,
    auth: authReducer,
    apiStatus: apiStatusReducer,
    moreSpaces: moreSpaceReducer,
    issues: issuesReducer,
    backlog: backlogReducer,
    timeEntries: timeEntriesReducer,
    clientQbMapping: clientQbMappingReducer,
    tabMapping: tabMappingReducer,
    vendorTagMapping: vendorTagMappingReducer,
    userRateMapping: userRateMappingReducer,
    reports: reportsReducer,
    roles: rolesReducer,
    permissions: permissionsReducer,
    exports: exportsReducer,
    saasBilling: saasBillingReducer,
    projectStatuses: projectStatusesReducer,
    projectSettings: projectSettingsReducer,
    systemLists: systemListsReducer,
    saasMasterModules: saasMasterModulesReducer,
    savedSearches: savedSearchesReducer,
    kanbanColumns: kanbanColumnsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }),
});

// Type definitions (for TypeScript migration in the future)
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
